import React from 'react';
import Image from 'next/image';
import Button from '@/lib/Button';
import Modal from '@/lib/Modal';
import { useGlobalStore } from '@/store';

type PopupProps = {
  isOpen: boolean;
  onDismiss: () => void;
};

const KycPopup = ({ isOpen, onDismiss }: PopupProps): JSX.Element => {
  const setView = useGlobalStore((store) => store.setActiveView);

  const handleClick = (): void => {
    setView('SELFIE_KYC');
  };

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <Modal.Body>
        <div className="d:w-1/2 d:flex d:flex-col d:items-center">
          <Image className="d:mr-4" src="/kyc.svg" width={100} height={10} alt="kyc" />
          <h2 className="font-semibold font-tasa mt-6 text-on-grey-normal text-2xl mr-4">
            Selfie verification and Aadhaar KYC
          </h2>
          <p className="mt-2 text-on-grey-subtle text-base mb-7 d:text-center">
            After verifying your selfie, we’ll take you to DigiLocker for Aadhaar number
            verification{' '}
          </p>
          <Button onClick={handleClick}>Continue to verify</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default KycPopup;
